import getUserMessagesStore from "../../../../stores/user-store/messages-store";
import Et3Button from "../../../../core/et3-button";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";

const LoadMoreButton = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const shouldShow = getUserMessagesStore().shouldShowLoadMoreButton.get();

  return shouldShow ? (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={1500}
      height={45}
      fDirection="row"
      alignItems="center"
      justifyContent="center"
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <Et3Button
        isEnabled={true}
        onClick={async () => {
          await getUserMessagesStore().getUserMessages({
            isLoadMore: true
          });
        }}
        size="MEDIUM"
        text="LOAD_MORE"
        type="GET"
      />
    </ET3Div>
  ) : null;
});
export default LoadMoreButton;
